import { Typography } from '@mui/material'
import { Box } from '@mui/system'

export const TokenLength = ({ length }: { length: number }) => {
    return (
        <Box display="flex" my={2} justifyContent="flex-end">
            <Typography className={'overline'} color={'#64748B'}>
                {length > 0 ? `${length} MEMBERSHIP AVAILABLE` : ''}
            </Typography>
        </Box>
    )
}
